import {getCurrentInstance} from 'vue'

export default function __(key) {
    const root = getCurrentInstance().appContext

    if (root?._translations && root?._translations[key]) {
        return root._translations[key];
    }

    return key;
}

export function themeVar(varName) {
    return getComputedStyle(document.documentElement)
        .getPropertyValue('--player-' + varName);
}

export function brightnessByColor(color) {
    const isHEX = color.indexOf("#") == 0
    const isRGB = color.indexOf("rgb") == 0

    let r = undefined
    let g = undefined
    let b = undefined

    if (isHEX) {
        const hasFullSpec = color.length == 7
        const m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g)
        if (m) {
            r = parseInt(m[0] + (hasFullSpec ? "" : m[0]), 16)
            g = parseInt(m[1] + (hasFullSpec ? "" : m[1]), 16)
            b = parseInt(m[2] + (hasFullSpec ? "" : m[2]), 16)
        }
    }
    if (isRGB) {
        const m = color.match(/(\d+){3}/g)
        if (m) {
            r = m[0]
            g = m[1]
            b = m[2]
        }
    }
    if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000
}

export const CTA_TITLE_MAX_LENGTH = 130

export function formatCtaTitle(title) {
    if (!title) {
        return ""
    }

    if (title.length <= CTA_TITLE_MAX_LENGTH) {
        return title
    }

    return `${title.slice(0, CTA_TITLE_MAX_LENGTH).trimEnd()}…`
}

export function buildShareUrlWithTime(seek, episodeHashId = null) {
    const url = new URL(window.location.href)
    const parts = url.pathname.split("/").filter(Boolean)

    if (episodeHashId && parts[0] === "embed" && parts.length >= 2) {
        if (parts.length >= 3) {
            parts[2] = episodeHashId
        } else {
            parts.push(episodeHashId)
        }

        url.pathname = `/${parts.join("/")}`
    }

    url.searchParams.set("t", String(Math.round(seek)))

    return url.toString()
}

export function resolveActiveCta(seek, ctas) {
    if (!ctas?.length) {
        return null
    }

    let winner = null
    let winnerIndex = -1

    ctas.forEach((cta, index) => {
        if (!cta.image || seek < cta.start || seek >= cta.end) {
            return
        }

        if (
            winner === null
            || cta.start > winner.start
            || (cta.start === winner.start && index > winnerIndex)
        ) {
            winner = cta
            winnerIndex = index
        }
    })

    return winner
}
